/* oxlint-disable no-underscore-dangle */
import StandardModelValidators, {nonNullValidator} from '../Standard/StandardModel.v1.validators';

const {getStandardSet: _, ...rest} = StandardModelValidators;

export const AuthoringStandardModelValidators = {
  ...rest,
  getAuthoringStandardSet() {
    const standardSetReplacements = this.__changeMap.getIn(
      ['__relationshipReplacements', 'authoring_standard_set_v1'],
      null
    );

    if (standardSetReplacements === null) {
      return this.getAuthoringStandardSet().isEmpty()
        ? ['Alignment to an existing standard set is required']
        : null;
    }

    const standardSetId =
      typeof standardSetReplacements === 'string'
        ? standardSetReplacements
        : standardSetReplacements?.getId?.();

    return nonNullValidator(standardSetId, 'Alignment to an existing standard set is required');
  }
};
